/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/einkaufs-statistik-web-button/shop.einkaufs-statistik-web-button.component.ts.
 */
import {ChangeDetectionStrategy, Component, Input, OnDestroy, SimpleChanges} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {View} from '../../../../models/view';
import {ShopViewComponent} from '../view/shop.view.component';

/**
 * Zweck: Beschreibt class ShopEinkaufsStatistikWebButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'einkaufs-statistik-web-button',
    templateUrl: 'shop.einkaufs-statistik-web-button.component.html',
    styleUrls: ['shop.einkaufs-statistik-web-button.component.scss'],
    standalone: false
})
export class ShopEinkaufsStatistikWebButtonComponent implements OnDestroy {
  @Input() artikel: Artikel;
  @Input() view: View;
  @Input() viewcomp: ShopViewComponent;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor() {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this.hideEinkaufsStatistikWeb(this.artikel);
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
  }

/**
 * Beschreibt Methode showEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  showEinkaufsStatistikWeb(artikel: Artikel) {
    this.viewcomp.showEinkaufsStatistikWeb(artikel);
  }

/**
 * Beschreibt Methode hideEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  hideEinkaufsStatistikWeb(artikel: Artikel) {
    this.viewcomp.hideEinkaufsStatistikWeb(artikel);
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (this.viewcomp.showEinkaufsstatitikWebDefault) {
      this.showEinkaufsStatistikWeb(this.artikel);
    }
  }
}
